import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

interface CustomerActionMenuProps {
  row: any;
  handleDelete?: (id: string) => void; // optional
  canEdit?: boolean;
  canDelete?: boolean;
}

export const CustomerActionMenu = ({
  row,
  handleDelete,
  canDelete = false, // default: false
  canEdit = true, // default: true (edit allowed by default)
}: CustomerActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        <i className="bi bi-three-dots-vertical fs-5 text-dark"></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ 
          elevation: 3,
          sx: { 
            fontFamily: 'var(--bs-font-sans-serif) !important',
            '& *': {
              fontFamily: 'var(--bs-font-sans-serif) !important'
            },
            '& .MuiMenuItem-root': {
              minHeight: '28px',
              padding: '4px 12px'
            },
            '& .MuiMenuItem-root .MuiListItemText-primary': {
              fontSize: '13px !important',
              fontWeight: '500 !important'
            }
          }
        }}
      >
        {/* ✅ Edit Option */}
        {canEdit && (
          <MenuItem
            component={Link}
            to={`/edit-customer/${row.original.customer_id}`}
            state={{ customerData: row.original }}
            onClick={handleClose}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Edit" />
          </MenuItem>
        )}

        {/* ✅ View Option (Always visible) */}
        <MenuItem
          component={Link}
          to={`/view-customer/${row.original.customer_id}`}
          onClick={handleClose}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View Details" />
        </MenuItem>

        {/* ✅ Delete Option (only for Admin or creator) */}
        {canDelete && handleDelete && (
          <MenuItem
            onClick={() => {
              handleDelete(row.original.customer_id);
              handleClose();
            }}
            sx={{ color: "error.main" }}
          >
            <ListItemIcon>
              <DeleteIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText primary="Delete" />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
